import _ from 'lodash'
import React from 'react'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/fontawesome-free-solid'
import { Field, reduxForm } from 'redux-form'

const ChecklistEdit = props => {
  const {
    handleSubmit, submitting, onSubmit, goBack, initialValues, project, errors,
    changeMainAreaOrder, changeDefectAreaOrder
  } = props
  if (!initialValues) return (<div/>)
  const { checklistId } = initialValues
  const mainAreas = project ? _.map(project.mainAreas, (mainArea, i) => (
    <div key={mainArea.id} className="col-md-12">
      <div className="card" style={{ marginBottom: '15px' }}>
        <div className="card-header">
          <div className="row">
            <div className="col-md-10 form-control-label">{mainArea.name}</div>
            <div className="col-md-2">
              <div className="float-right">
                <button type="button" className="btn" disabled={i === 0}
                        onClick={() => changeMainAreaOrder(project, i, true)}>
                  <FontAwesomeIcon icon={faAngleUp}/>
                </button>
                <span>&nbsp;&nbsp;&nbsp;</span>
                <button type="button" className="btn" disabled={i === project.mainAreas.length - 1}
                        onClick={() => changeMainAreaOrder(project, i, false)}>
                  <FontAwesomeIcon icon={faAngleDown}/>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          {
            _.map(mainArea.defectAreas, (defectArea, j) => (
              <div key={defectArea.id} className="form-group row">
                <label htmlFor={`defectArea-${defectArea.id}`}
                       className="col-md-6 col-form-label">{defectArea.name}</label>
                <div className="col-md-6">
                  <div className="float-right">
                    <div className="form-check form-check-inline">
                      <Field name={`defectArea-${defectArea.id}`} component="input" type="radio" value="true"/>
                      <label className="form-check-label" htmlFor={`defectArea-${defectArea.id}`}>Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Field name={`defectArea-${defectArea.id}`} component="input" type="radio" value="false"/>
                      <label className="form-check-label" htmlFor={`defectArea-${defectArea.id}`}>No</label>
                    </div>
                    <div className="form-check-inline">
                      <button type="button" className="btn" disabled={j === 0}
                              onClick={() => changeDefectAreaOrder(project, i, j, true)}>
                        <FontAwesomeIcon icon={faAngleUp}/>
                      </button>
                      <span>&nbsp;&nbsp;&nbsp;</span>
                      <button type="button" className="btn" disabled={j === mainArea.defectAreas.length - 1}
                              onClick={() => changeDefectAreaOrder(project, i, j, false)}>
                        <FontAwesomeIcon icon={faAngleDown}/>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )) : undefined
  return (
    <div>
      <div className="pd-x-20 pd-sm-x-30 pd-t-20 pd-sm-t-30">
        <h4 className="tx-gray-800 mg-b-5">แก้ไขลิสต์ตรวจสอบรายการประจำวัน</h4>
      </div>
      <div className="br-pagebody">
        <div className="br-section-wrapper">
          <form onSubmit={handleSubmit((values) => {onSubmit(checklistId, project, values)})}>
            <div className="row align-items-center justify-content-center">
              <div className="card col-md-12">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label htmlFor="project" className="col-md-3 col-form-label form-control-label">โครงการ :</label>
                        <div className="col-md-9">
                          <input id="project" name="project" placeholder="Project" className="form-control"
                                 value={project.name} disabled={true}/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {mainAreas}
                  </div>
                  {errors.list ?
                    <div className="row">
                      <span className="text-danger">{errors.list}</span>
                    </div> : undefined}
                </div>
              </div>
            </div>
            <br/>
            <div className="row justify-content-end">
              <button type="submit" className="btn btn-teal" disabled={submitting}>แก้ไข</button>
              <span>&nbsp;&nbsp;&nbsp;</span>
              <button type="button" className="btn btn-secondary" disabled={submitting} onClick={goBack}>กลับ</button>
            </div>
          </form>
        </div>
      </div>    
    </div>
  )
}

export default reduxForm({
  form: 'checklist-edit',
  enableReinitialize: true,
})(ChecklistEdit)


// WEBPACK FOOTER //
// ./src/components/ChecklistEdit.js